import { ActionsUnion, createAction } from "../definitions";
import { ActiveUserActionTypes } from "./types";

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ActiveUserActions = {
    set: (payload: string[]) => createAction(ActiveUserActionTypes.SET_ACTIVE_USERS, payload),
    clear: () => createAction(ActiveUserActionTypes.CLEAR_ACTIVE_USERS)
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ActiveUserActions = ActionsUnion<typeof ActiveUserActions>;